module.exports = __webpack_public_path__ + "static/media/logo.b212a8e8.png";